import React, { useState, forwardRef } from "react";
import { Input } from "./Input";
import { Button } from "../button";
import Eye from "./assets/Eye.svg";
import EyeClosed from "./assets/EyeClosed.svg";
import styles from "./PasswordInput.module.scss";

export const PasswordInput = forwardRef(function PasswordInput(
  {
    value,
    onChange,
    onBlur,
    placeholder = "",
    className = "",
    autoComplete = "current-password",
    disabled = false,
    mask,
    replacement,
    ...props
  },
  ref,
) {
  const [visible, setVisible] = useState(false);

  const toggle = () => setVisible((v) => !v);

  return (
    <div className={styles.inputBlock}>
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
        mask={mask}
        replacement={replacement}
        autoComplete={autoComplete}
        {...props}
      />

      <div className={styles.button}>
        <Button
          variant="ghost"
          size="small"
          leftIcon={
            <img src={visible ? Eye : EyeClosed} alt="Eye" width={25} />
          }
          onClick={toggle}
        />
      </div>
    </div>
  );
});
